import { useEffect, useState } from "react";
import "../../styles/modal.css";

export default function AdminCreateModal({ open, onClose, onSubmit }) {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    username: "",
    password: "",
    tel: "",
  });
   useEffect(() => {
    if (open) document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, [open]);

  if (!open) return null;

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  function handleSubmit(e) {
    e.preventDefault();
    onSubmit(form);
  }

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalCard" onClick={(e) => e.stopPropagation()}>
        <h3>Ajouter un administrateur</h3>

        <form onSubmit={handleSubmit} className="modalForm">

  <div className="formGrid">
    <Input label="Prénom" name="firstName" required onChange={handleChange} />
    <Input label="Nom" name="lastName" onChange={handleChange} />

    <Input label="Email" name="email" type="email" required onChange={handleChange} />
    <Input label="Username" name="username" required onChange={handleChange} />

    <Input label="Mot de passe" name="password" type="password" required onChange={handleChange} />
    <Input label="Téléphone" name="tel" required onChange={handleChange} />

    <Input label="WhatsApp (optionnel)" name="whatsapp" onChange={handleChange} />
    <Input label="Adresse (optionnelle)" name="adress" onChange={handleChange} />
  </div>

  <div className="modalActions">
    <button type="button" className="btnGhost" onClick={onClose}>
      Annuler
    </button>
    <button className="btnPrimary">
      Créer
    </button>
  </div>

</form>
      </div>
    </div>
  );
}

function Input({ label, ...props }) {
  return (
    <div className="formGroup">
      <label>{label}</label>
      <input {...props} />
    </div>
  );
}
